import { GetRollfiCompanies } from '../../../domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetRollfiCompanies extends BaseHttpService<GetRollfiCompanies.Model> implements GetRollfiCompanies {
  async getRollfiCompanies(params: GetRollfiCompanies.Params): Promise<GetRollfiCompanies.Model> {
    return await this.request('get', {}, params);
  }
}
